export default "__VITE_ASSET__DZLPxxV5__"